module.exports = __webpack_public_path__ + "static/media/sm.890ad891.svg";